import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Language } from "../../App";
import { LuHash } from "react-icons/lu";

export default function SearchHashtags({ data }) {
  const { lang } = useContext(Language);
  const navigate = useNavigate();

  if (!data || data.length === 0) {
    return null;
  }

  const handleHashtagClick = (tag) => {
    if (!tag) return;
    const cleanTag = String(tag).replace(/^#/, "").trim();
    window.scrollTo({ top: 0, behavior: "smooth" });
    navigate(`/search/posts?keyword=${encodeURIComponent(cleanTag)}`);
  };

  return (
    <div className="search-hashtags-panel">
      <div className="search-hashtags-header">
        <h3 className="search-hashtags-title">
          <LuHash size={16} color="#00BADA" />
          <span>{lang?.hashtags || "Trending Hashtags"}</span>
        </h3>
      </div>
      <div className="search-hashtags-body">
        {data.map((item, index) => {
          const rawTag = typeof item === "string" ? item : item?.tag || item?.name || "";
          if (!rawTag) return null;
          const tagText = String(rawTag).trim();
          const displayTag = tagText.startsWith("#") ? tagText : `#${tagText}`;

          return (
            <button
              key={index}
              type="button"
              className="search-hashtag-chip"
              onClick={() => handleHashtagClick(tagText)}
            >
              <span>{displayTag}</span>
              {item?.count > 0 && (
                <span className="search-hashtag-count">{item.count}</span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
